export default __webpack_public_path__ + "static/media/join-bottom.27d84c79.svg";